const VIDEO_FORMAT = 'video/mp4';

export const isVideo = (format: string) => format === VIDEO_FORMAT;
